import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';
import teczLogo from '../Assets/teczo.png';

const NAV_ITEMS = [
  { id: 'home',     label: 'Home',     route: '/' },
  { id: 'about',    label: 'About Us', route: '/about' },
  { id: 'services', label: 'Services', route: '/services' },
  { id: 'contact',  label: 'Contact',  route: '/contact' },
];

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navRef = useRef(null);

  const currentPage = NAV_ITEMS.find(n => n.route === location.pathname)?.id || 'home';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setMobileOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const go = (route) => {
    navigate(route);
    setMobileOpen(false);
  };

  return (
    <div
      className="dw-nav__wrapper"
      ref={navRef}
      style={{ boxShadow: scrolled ? '0 2px 20px rgba(0,0,0,0.06)' : 'none' }}
    >
      <div className="dw-nav__inner">

        {/* Logo — bare image + two-line text, no container */}
        <div className="dw-nav__brand" onClick={() => go('/')}>
          <img src={teczLogo} alt="Teczo" className="dw-nav__logo-img" />
          <span className="dw-nav__brand-divider">|</span>
          <div>
            <div className="dw-nav__brand-name">DigitalWorks</div>
            <div className="dw-nav__brand-sub">Teczo Subsidiary</div>
          </div>
        </div>

        {/* Desktop center links */}
        <div className="dw-nav__links">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className={`dw-nav__link ${currentPage === item.id ? 'dw-nav__link--active' : ''}`}
              onClick={() => go(item.route)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <button className="dw-nav__cta" onClick={() => go('/contact')}>
          Start Project
        </button>

        {/* Hamburger */}
        <button
          className="dw-nav__hamburger"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Toggle menu"
        >
          {mobileOpen
            ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
          }
        </button>
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="dw-nav__mobile-menu">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className={`dw-nav__mobile-link ${currentPage === item.id ? 'dw-nav__mobile-link--active' : ''}`}
              onClick={() => go(item.route)}
            >
              {item.label}
            </button>
          ))}
          <div className="dw-nav__mobile-cta-wrap">
            <button className="dw-nav__mobile-cta" onClick={() => go('/contact')}>
              Start Project
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
